var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427322566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.81033 17.191C8.24378 17.191 9.40582 16.0289 9.40582 14.5955C9.40582 13.162 8.24378 12 6.81033 12C5.37688 12 4.21484 13.162 4.21484 14.5955C4.21484 16.0289 5.37688 17.191 6.81033 17.191Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.1922 17.191C18.6256 17.191 19.7877 16.0289 19.7877 14.5955C19.7877 13.162 18.6256 12 17.1922 12C15.7587 12 14.5967 13.162 14.5967 14.5955C14.5967 16.0289 15.7587 17.191 17.1922 17.191Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0017 6.81011C13.4352 6.81011 14.5972 5.64807 14.5972 4.21463C14.5972 2.78118 13.4352 1.61914 12.0017 1.61914C10.5683 1.61914 9.40625 2.78118 9.40625 4.21463C9.40625 5.64807 10.5683 6.81011 12.0017 6.81011Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0021 22.3824C12.0021 19.5155 9.67796 17.1914 6.81109 17.1914C3.94419 17.1914 1.62012 19.5155 1.62012 22.3824",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.3839 22.3824C22.3839 19.5155 20.0598 17.1914 17.1929 17.1914C14.3261 17.1914 12.002 19.5155 12.002 22.3824",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.1925 11.9996C17.1925 9.1327 14.8684 6.80859 12.0015 6.80859C9.13465 6.80859 6.81055 9.1327 6.81055 11.9996",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1e6ce5029b33cde61ec81d5dbc7d7182.svg";
export { ForwardRef as ReactComponent };